
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  data: () => ({
    bibFile: null as File | null,
    awardsFile: null as File | null,
    uploadingBib: false,
    uploadingAwards: false,
    bibMsg: "",
    awardsMsg: "",

    // 科研奖励：手动逐条添加
    awardRank: "",
    awardTrack: "",
    awardName: "",
    awardYear: "",
    awardLinkTag: "",
    awardLinkUrl: "",
    awardLinks: [] as { tag: string; url: string }[],
    addingAward: false,
    awardMsg: "",
    extraAwards: [] as any[],

    // 发表论文：Excel 上传
    xlsxFile: null as File | null,
    uploadingXlsx: false,
    xlsxMsg: "",
    extraPubs: [] as any[],
  }),
  mounted() {
    this.loadExtraAwards();
    this.loadExtraPubs();
  },
  methods: {
    onPickBib(e: Event) {
      const f = (e.target as HTMLInputElement)?.files?.[0] || null;
      this.bibFile = f;
      this.bibMsg = "";
    },
    onPickAwards(e: Event) {
      const f = (e.target as HTMLInputElement)?.files?.[0] || null;
      this.awardsFile = f;
      this.awardsMsg = "";
    },
    uploadBib() {
      if (!this.bibFile) return;
      this.uploadingBib = true;
      this.bibMsg = "";
      const data = new FormData();
      data.append("file", this.bibFile);
      axios
        .post(Vue.prototype.apiUrl("upload-publications-bib"), data, {
          headers: { "Content-Type": "multipart/form-data" },
        } as any)
        .then(() => {
          this.bibMsg = "已更新：发表论文文件上传成功。";
          this.bibFile = null;
        })
        .catch(() => {
          this.bibMsg = "上传失败：请检查网络/服务器日志。";
        })
        .finally(() => {
          this.uploadingBib = false;
        });
    },
    uploadAwards() {
      if (!this.awardsFile) return;
      this.uploadingAwards = true;
      this.awardsMsg = "";
      const data = new FormData();
      data.append("file", this.awardsFile);
      axios
        .post(Vue.prototype.apiUrl("upload-awards-txt"), data, {
          headers: { "Content-Type": "multipart/form-data" },
        } as any)
        .then(() => {
          this.awardsMsg = "已更新：科研奖励文件上传成功。";
          this.awardsFile = null;
        })
        .catch(() => {
          this.awardsMsg = "上传失败：请检查网络/服务器日志。";
        })
        .finally(() => {
          this.uploadingAwards = false;
        });
    },

    addAwardLink() {
      const tag = (this.awardLinkTag || "").trim();
      const url = (this.awardLinkUrl || "").trim();
      if (tag && url) {
        this.awardLinks.push({ tag, url });
        this.awardLinkTag = "";
        this.awardLinkUrl = "";
      }
    },
    addAward() {
      if (!this.awardRank.trim() || !this.awardName.trim()) {
        this.awardMsg = "名次和竞赛名称不能为空。";
        return;
      }
      this.addingAward = true;
      this.awardMsg = "";
      axios
        .post(Vue.prototype.apiUrl("add-award"), {
          rank: this.awardRank.trim(),
          track: this.awardTrack.trim(),
          name: this.awardName.trim(),
          year: this.awardYear.trim(),
          links: this.awardLinks,
        })
        .then(() => {
          this.awardMsg = "已添加该条奖励。";
          this.awardRank = "";
          this.awardTrack = "";
          this.awardName = "";
          this.awardYear = "";
          this.awardLinks = [];
          this.loadExtraAwards();
        })
        .catch(() => {
          this.awardMsg = "添加失败：请检查网络/服务器日志。";
        })
        .finally(() => {
          this.addingAward = false;
        });
    },
    loadExtraAwards() {
      axios.get(Vue.prototype.apiUrl("extra-awards")).then((r) => {
        this.extraAwards = r.data || [];
      });
    },
    deleteAward(a: any) {
      if (!window.confirm(`确定删除这条手动奖励吗？\n${a.name}`)) return;
      axios.post(Vue.prototype.apiUrl("delete-award"), { _id: a._id }).then(() => {
        this.loadExtraAwards();
      });
    },

    onPickXlsx(e: Event) {
      const f = (e.target as HTMLInputElement)?.files?.[0] || null;
      this.xlsxFile = f;
      this.xlsxMsg = "";
    },
    uploadXlsx() {
      if (!this.xlsxFile) return;
      this.uploadingXlsx = true;
      this.xlsxMsg = "";
      const data = new FormData();
      data.append("file", this.xlsxFile);
      axios
        .post(Vue.prototype.apiUrl("upload-publications-xlsx"), data, {
          headers: { "Content-Type": "multipart/form-data" },
        } as any)
        .then((r) => {
          const added = r.data && r.data.added;
          const total = r.data && r.data.total;
          this.xlsxMsg = `已追加 ${added} 条论文（去重后共 ${total} 条）。`;
          this.xlsxFile = null;
          this.loadExtraPubs();
        })
        .catch(() => {
          this.xlsxMsg = "上传失败：请检查文件格式/服务器日志。";
        })
        .finally(() => {
          this.uploadingXlsx = false;
        });
    },
    loadExtraPubs() {
      axios.get(Vue.prototype.apiUrl("extra-publications")).then((r) => {
        this.extraPubs = r.data || [];
      });
    },
    deleteExtraPub(p: any) {
      if (!window.confirm(`确定删除这条手动上传的论文吗？\n${p.name}`)) return;
      axios.post(Vue.prototype.apiUrl("delete-extra-publication"), { _id: p._id }).then(() => {
        this.loadExtraPubs();
      });
    },
    clearExtraPubs() {
      if (!window.confirm("确定清空所有手动上传的论文吗？")) return;
      axios.post(Vue.prototype.apiUrl("clear-extra-publications")).then(() => {
        this.loadExtraPubs();
      });
    },
  },
});
